import api from '@/plugins/api';
// The list is read in full: the list-view selector and the "shared with me" grouping need every filter, and a
// silently truncated first page would hide shared filters. 100 is the maximum page size opref accepts.
const SAVED_FILTERS_PAGE_SIZE = 100;
export async function fetchSavedFilters(entityType, application) {
    const filters = [];
    let page = 1;
    let totalPages;
    do {
        const response = await api.get('/portal/saved-filters', {
            params: { application, entityType, page, pageSize: SAVED_FILTERS_PAGE_SIZE },
        });
        const body = response.data;
        filters.push(...body.data);
        totalPages = body.pagination?.totalPages ?? 1;
        page++;
    } while (page <= totalPages);
    return filters;
}
export async function fetchSavedFilterDetail(id) {
    const response = await api.get(`/portal/saved-filters/${id}`);
    return response.data.data;
}
export async function createSavedFilter(body) {
    const response = await api.post('/portal/saved-filters', body);
    return response.data.data;
}
export async function updateSavedFilter(id, body) {
    const response = await api.put(`/portal/saved-filters/${id}`, body);
    return response.data.data;
}
export async function deleteSavedFilter(id) {
    await api.delete(`/portal/saved-filters/${id}`);
}
export async function fetchAccessGrants(id) {
    const response = await api.get(`/portal/saved-filters/${id}/access-grants`);
    return response.data.data;
}
export async function setAccessGrant(id, body) {
    const response = await api.put(`/portal/saved-filters/${id}/access-grants`, body);
    return response.data.data;
}
